import { DateTime } from "luxon";

export const WORLDS_OLDEST_PERSONS_BIRTHDATE = "1907-03-04";
export const WORLDS_OLDEST_PERSONS_BIRTHDATE_DATETIME = DateTime.fromISO(
  WORLDS_OLDEST_PERSONS_BIRTHDATE
);
export const OLDEST_ACCEPTABLE_BIRTHDATE = DateTime.now().minus({ years: 115 });
export const OLDEST_BIRTHDATE_SANS_WARNING = DateTime.now().minus({
  years: 100,
});
export const YOUNGEST_ACCEPTABLE_BIRTHDATE = DateTime.now().minus({
  months: 1,
});
export const PW_YOUNGEST_ACCEPTABLE_BIRTHDATE = DateTime.now()
  .minus({ months: 1 })
  .toISODate();
export const OLDEST_COLLECTED_RECEIVED_DATE = "2000-01-01T00:00";
export const OLDEST_HISTORICAL_COLLECTED_RECEIVED_DATE = "1950-01-01T00:00";
